import { Block } from '@sanity/types/dist/dts';

import { PortableText } from '../../src/cms-blog-api/sanity';

type PostBodyProps = {
  blocks?: Block[];
};

export default function PostBody({ blocks }: PostBodyProps) {
  return <div className="prose prose-sm max-w-none">{blocks && <PortableText blocks={blocks} />}</div>;
}
